/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This tool computes the population standard deviation (dividing by n). Sample standard deviation divides by n − 1 and is slightly larger.`)
};

const es_st_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta herramienta calcula la desviación estándar poblacional (dividiendo entre n). La desviación estándar muestral divide entre n − 1 y es ligeramente mayor.`)
};

const de_st_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Tool berechnet die Standardabweichung der Grundgesamtheit (Division durch n). Die Stichproben-Standardabweichung teilt durch n − 1 und ist etwas größer.`)
};

const nl_st_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze tool berekent de populatiestandaardafwijking (gedeeld door n). De steekproefstandaardafwijking wordt gedeeld door n − 1 en is iets groter.`)
};

const fr_st_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet outil calcule l'écart-type de population (en divisant par n). L'écart-type d'échantillon divise par n − 1 et est légèrement plus grand.`)
};

const it_st_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo strumento calcola la deviazione standard di popolazione (dividendo per n). La deviazione standard campionaria divide per n − 1 ed è leggermente maggiore.`)
};

const pt_br2_st_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ferramenta calcula o desvio padrão populacional (dividindo por n). O desvio padrão amostral divide por n − 1 e é um pouco maior.`)
};

const pt_st_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ferramenta calcula o desvio-padrão populacional (a dividir por n). O desvio-padrão amostral divide por n − 1 e é ligeiramente maior.`)
};

const ja_st_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このツールは母標準偏差を計算します(nで割ります)。標本標準偏差はn − 1で割るため、わずかに大きい値になります。`)
};

const zh_st_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本工具计算的是总体标准差（除以 n）。样本标准差则除以 n − 1，结果会略大一些。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_faq_a3", locale)
	if (locale === "en") return en_st_faq_a3(inputs)
	if (locale === "es") return es_st_faq_a3(inputs)
	if (locale === "de") return de_st_faq_a3(inputs)
	if (locale === "nl") return nl_st_faq_a3(inputs)
	if (locale === "fr") return fr_st_faq_a3(inputs)
	if (locale === "it") return it_st_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_st_faq_a3(inputs)
	if (locale === "pt") return pt_st_faq_a3(inputs)
	if (locale === "ja") return ja_st_faq_a3(inputs)
	return zh_st_faq_a3(inputs)
};